const attr = '--scroll-y';

export const lockScroll = () => {
  const body = document.body;
  setScrollY();
  const scrollY = document.documentElement.style.getPropertyValue(attr);
  body.style.position = 'fixed';
  body.style.top = `-${scrollY}`;
  body.style.width = '100%';
};

export const setScrollY = () => {
  document.documentElement.style.setProperty(attr, `${window.scrollY}px`);
};

export const unlockScroll = () => {
  const body = document.body;
  const scrollY = body.style.top;
  body.style.position = '';
  body.style.top = '';
  body.style.width = '';
  if (scrollY === '') {
    // console.info('NO SCROLL', scrollY);
    return;
  }
  window.scrollTo(0, parseInt(scrollY, 10) * -1);
};
